import React from "react";
import styles from "./evaluation_progress.module.scss";

const EvaluationProgress = ({ stepperState, is_registered }) => {
  return (
    <ul className={styles.steps}>
      <li className={`${stepperState >= 1 ? `${styles.active}` : ""}`}>
        <div className={styles.number_name}>
          <div className={styles.step_number}>1</div>
          <div className={styles.step_name}>Country</div>
        </div>
        <div className={styles.step_bar}></div>
      </li>
      <li className={`${stepperState >= 2 ? `${styles.active}` : ""}`}>
        <div className={styles.number_name}>
          <div className={styles.step_number}>2</div>
          <div className={styles.step_name}>Course Level</div>
        </div>
        <div className={styles.step_bar}></div>
      </li>
      <li className={`${stepperState >= 3 ? `${styles.active}` : ""}`}>
        <div className={styles.number_name}>
          <div className={styles.step_number}>3</div>
          <div className={styles.step_name}>Specialization</div>
        </div>
        <div className={styles.step_bar}></div>
      </li>
      <li className={`${stepperState >= 4 ? `${styles.active}` : ""}`}>
        <div className={styles.number_name}>
          <div className={styles.step_number}>4</div>
          <div className={styles.step_name}>Department</div>
        </div>
        <div className={styles.step_bar}></div>
      </li>
      <li className={`${stepperState >= 5 ? `${styles.active}` : ""}`}>
        <div className={styles.number_name}>
          <div className={styles.step_number}>5</div>
          <div className={styles.step_name}>Intake</div>
        </div>
        <div className={styles.step_bar}></div>
      </li>

      <li className={`${stepperState >= 6 ? `${styles.active}` : ""}`}>
        <div className={styles.number_name}>
          <div className={styles.step_number}>6</div>
          <div className={styles.step_name}>Exam</div>
        </div>
        <div className={styles.step_bar}></div>
      </li>

      <li className={`${stepperState >= 7 ? `${styles.active}` : ""}`}>
        <div className={styles.number_name}>
          <div className={styles.step_number}>7</div>
          <div className={styles.step_name}>Education</div>
        </div>
        <div className={styles.step_bar}></div>
      </li>

      <li className={`${stepperState >= 8 ? `${styles.active}` : ""}`}>
        <div className={styles.number_name}>
          <div className={styles.step_number}>8</div>
          <div className={styles.step_name}>Objective</div>
        </div>
        {is_registered == false && <div className={styles.step_bar}></div>}
      </li>

      {is_registered == false && (
        <li className={`${stepperState >= 9 ? `${styles.active}` : ""}`}>
          <div className={styles.number_name}>
            <div className={styles.step_number}>9</div>
            <div className={styles.step_name}>Sign Up</div>
          </div>
        </li>
      )}
    </ul>
  );
};

export default EvaluationProgress;
